import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"

import OpenPositionProf from "../../components/openPositionProf"
import HeaderBg from "../../images/careers/pexels-christina-morillo-1181395.jpg"

const CorporateOperations = ({ data }) => {
  const coOperation = data.allSanityOpenPositions.edges.map((item) => item.node)
  return (
    <Layout>
      <SEO title="Corporate Operations" />
      <div className="page-header">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-xl-10">
              <div className="header-text">
                <h1 className="text-black mb-4">Corporate Operations</h1>
                {/* <p className="lead">
                  From accidents and injuries to hit-and-runs and theft, it’s
                  important to keep your car insured so you’re prepared if an
                  accident occurs.
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div
          className="header-bg"
          style={{ backgroundImage: `url(${HeaderBg})` }}
        />
      </div>
      <div className="careers-page">
        {/* <div className="careers-hero positions-corporate has-overlay">
          <div className="container">
            <h1 className="display-4 text-center">Corporate Operations</h1>
          </div>
        </div> */}
        <div className="py-110">
          <div className="container">
            <h2 className="my_h1 text-center">Open Positions</h2>
            <div className="my_h1_hr"></div>
            <OpenPositionProf jobs={coOperation} />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default CorporateOperations
export const SePageQuery = graphql`
  query {
    allSanityOpenPositions(
      filter: {
        careerCategories: {
          elemMatch: { title: { eq: "Corporate Operations" } }
        }
      }
    ) {
      edges {
        node {
          title
          slug {
            current
          }
          excerpt
          location
          careerCategories {
            title
          }
          _createdAt(formatString: "MM-DD-YY")
        }
      }
    }
  }
`
